import { Injectable } from '@angular/core';
import { StorageUtil } from '../utils/storage.util';
import { NavigationEnd, Router } from '@angular/router';
import { FormatUtil } from '../utils/format.util';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GtagService {
  private initialized = false;
  private userId: string;
  private marinaId: string;

  constructor(private router: Router) {}

  init(): void {
    var isProd =
      window.location.href.includes('www2.easymarine.com.br') ?? false;
    if (!isProd || this.initialized) return;
    this.initialized = true;

    this.initializeListening();
  }

  private initializeListening() {
    this.userId = StorageUtil.getUserId()?.toString() ?? '';
    this.marinaId = StorageUtil.getMarinaId()?.toString() ?? '';

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        let pageTitle = this.getPageTitle(event.urlAfterRedirects);
        this.send('page_view', {
          page_location: window.location.href,
          page_path: event.urlAfterRedirects,
          page_title: pageTitle,
          user: this.userId,
          marina: this.marinaId,
        });
      }
    });
  }

  sendEvent(eventName: string): void {
    if (!this.userId || !this.marinaId) {
      this.userId = StorageUtil.getUserId()?.toString() ?? '';
      this.marinaId = StorageUtil.getMarinaId()?.toString() ?? '';
    }
    this.send(eventName, {
      user: this.userId,
      marina: this.marinaId,
    });
  }

  private send(eventName: string, params: Record<string, any> = {}): void {
    var isProd =
      window.location.href.includes('www2.easymarine.com.br') ?? false;
    if (!isProd) return;
    gtag('event', eventName, params);
  }

  private getPageTitle(page: string) {
    let pageTitle = page.split('/').pop();
    pageTitle = FormatUtil.firstLetterUppercase(pageTitle);
    pageTitle = FormatUtil.replaceSpecialCharacters(pageTitle);
    return pageTitle;
  }
}
